<template>
  <div id="testDataView">
    <div v-if="$route.name === 'testdata'">
      <h1>{{ $t('privatePage.testdata_header') }}</h1>
      <test-data-export-editor :testMethods="exportOptions.testMethods"
                                v-on:onSubmit="onSubmitTestDataExport"/>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TestDataExportEditor from '../../components/testdata/testdataexporteditor'

export default {
  name: 'test-data-export-view',
  components: {
    TestDataExportEditor
  },
  data() {
    return {
      exportOptions: {
        testMethods: []
      }
    }
  },
  computed: {
    ...mapGetters('testMethodsModule', ['activeStandardTestMethods'])
  },
  methods: {
    ...mapActions('testMethodsModule', {
      getTestMethods: 'getActiveStandardTestMethods'
    }),
    ...mapActions('testDataModule', {
      exportTestData: 'exportTestData'
    }),
    onSubmitTestDataExport: function(data) {
      this.exportTestData(data)
    }
  },
  created() {
    this.getTestMethods()
      .then(data => {
        this.activeStandardTestMethods.forEach(tm => {
          let testMethod = {
            value: tm.id,
            text: tm.name
          }
          this.exportOptions.testMethods.push(testMethod)
        })
      })
      .catch(error => {
        this.showErrorMessage(error)
      })
  }
}
</script>
